import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';

const handler = ({ httpClient }) => httpClient.get(URLS.user.logOut);

export default makeEntityScaffold('SAGA.API.LOG_OUT', handler);
